export default `float de(vec3 p) {
    p = abs(p);
    if (p.x < max(p.y, p.z)) p = p.yzx;
    if (p.x < max(p.y, p.z)) p = p.yzx;
    float b = max(max(max(
      dot(p, normalize(vec3(1.0, 1.0, 1.0))),
      dot(p.xz, normalize(vec2(PHI+1, 1.0)))),
      dot(p.yx, normalize(vec2(1.0, PHI)))),
      dot(p.xz, normalize(vec2(1.0, PHI))));
    float l = length(p);
    return l - 1.5 - 0.2 * (1.5 / 2)* cos(min(sqrt(1.01 - b / l)*(PI / 0.25), PI));
  }`